import { observer } from 'mobx-react-lite'
import { type OfferModalViewModel } from '@/features/opportunities/offers/OfferModalViewModel'
import { OfferModal } from '@/features/opportunities/offers/components/OfferModal'

export interface OfferModalContainerProps {
  vm: OfferModalViewModel
}

export const OfferModalContainer = observer(function OfferModalContainer({
  vm,
}: OfferModalContainerProps) {
  return (
    <OfferModal
      id={vm.id}
      showing={vm.modal.showing}
      workspaceName={vm.workspaceName}
      displayName={vm.displayName}
      championClientName={vm.championClientName}
      proCut={vm.proCut}
      jobSpecs={vm.jobSpecs}
      expirationAction={vm.offerExpirationAction}
      timeUntilExpiration={vm.timeUntilExpiration}
      isAcceptPending={vm.acceptOpportunity.pending}
      onAccept={vm.acceptOpportunity}
      acceptFailed={vm.acceptOpportunity.rejected}
      acceptError={vm.acceptOpportunity.error}
      onDismissAcceptError={vm.acceptOpportunity.reset}
      isDeclinePending={vm.declineOpportunity.pending}
      onDecline={vm.declineOpportunity}
      declineFailed={vm.declineOpportunity.rejected}
      declineError={vm.declineOpportunity.error}
      onDismissDeclineError={vm.declineOpportunity.reset}
    />
  )
})
